import React from "react";
import { useInView } from "react-intersection-observer";
import Services from "../Components/Services";
import Contact from "../Components/Contact";
import About from "../Components/About";
import Landing from "../Components/Landing";

const Home = () => {
  return (
    <div className="bg-gray-50">
      <Landing />
      <About />
      <Services/>
      <Contact/>
    </div>
  );
};

export default Home;
